import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import StepIndicator from '../../components/step-indicator'
import DirectDebit from '../../components/direct-debit'
import DirectDebitGuarantee from '../../components/direct-debit-guarantee'
import DirectDebitSubmitButtons from '../../components/direct-debit-submit-buttons'

import initialValues from '../../data/initialValues'
import validation from '../../validation/membership'
import MembershipFormContext from '../../context/membership'
import { getSS, setSS, cleanObject, loadIndexPage } from '../../helpers'
import { saveMembership } from '../../api'

const RegularBilling: React.FC = (props: any) => {

  const [ invalidBankDetailsMessage, setInvalidBankDetailsMessage ] = useState('')
  const navigate = useNavigate()
  const params = useParams()
  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const globals = (window as any).KEW.globals
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  let membership = getSS('membership')

  if (!membership || membership.process_payment) {
    loadIndexPage(navigate, url)
  }

  useEffect(() => {
    document.title = 'Bank details - ' + (window as any).KEW.collections.membership_form[0].meta_title
  })

  useEffect(() => {
    membershipForm.preSelectedMembership ? membershipForm.setCurrentStep(3) : membershipForm.setCurrentStep(4)
  }, [membershipForm])

  const onSubmit = async (data: any) => {
    console.log(data);
    setSS('payment_regular', data);
    membershipForm.showLoading()
    data = { ...membership, ...data }
    // store a redacted version of account number
    data.bank_account_number_redacted = data.bank_account_account_number.replace(/^.{4}/g, 'xxxx');
    data.process_payment = true;
    data.bacs_sun = globals.bacs_sun;
    if (data.optins_giftaid) {
      data.giftaid_amount = (data.amount * 0.25).toFixed(2);
    }
    const savedMembership: any = await saveMembership(data)
    if (savedMembership?.status === 200) {
      data = savedMembership.data
      setSS('membership', data);
      membershipForm.hideLoading()
      navigate(`/membership/${url}/thanks`)
    } else {
      membershipForm.hideLoading()
      const apiError = savedMembership.headers['api-error']
      if (apiError === 'PCAPredict:Invalid' || apiError === 'PCAPredict:InvalidAccountNumber' || apiError === 'PCAPredict:InvalidSortCode') {
        setInvalidBankDetailsMessage('Invalid bank details, please check your account number and sort code and try again');
        (document as any).getElementById("m-account-holder").scrollIntoView(true);
        return
      } else if (apiError === 'PCAPredict:NotDirectDebitCapable') {
        setInvalidBankDetailsMessage('Sorry - it\'s not possible to set up a direct debit using the bank account you\'ve specified. Please try again using a different account');
        (document as any).getElementById("m-account-holder").scrollIntoView(true);
        return
      } else {
        setInvalidBankDetailsMessage('')
      }
      setSS('api-error', apiError)
      navigate(`/membership/${url}/failed`)
      return
    }
  }

  return (
    <>
      { membership &&
        <>
          <Formik
            initialValues={ initialValues.payment_regular }
            validationSchema={ validation.payment_regular }
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={ onSubmit }>
            {(props: any) => {
              props.errors = cleanObject(props.errors)
              return (
              <>
                <Form name="membershipForm">
                  <StepIndicator />
                  <DirectDebit
                    {...props}
                    invalidBankDetailsMessage={invalidBankDetailsMessage}
                    setInvalidBankDetailsMessage={setInvalidBankDetailsMessage}
                  />
                  <DirectDebitGuarantee />
                  <DirectDebitSubmitButtons {...props} />
                </Form>
              </>
              )
            }}
          </Formik>
        </>
      }
    </>
  )
}

export default RegularBilling